var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"videoJsCon"}},[_c('video',{ref:"videoP",staticClass:"video-js vjs-default-skin",staticStyle:{"width":"100%"},attrs:{"crossOrigin":"anonymous","id":"main_video","controls":"","preload":"auto"}},[_c('source',{attrs:{"type":"video/mp4","src":_vm.url + _vm.gettimes()}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }